// Copyright (c) 2017 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

export const showRequired = isRequired =>
    isRequired ?
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div> :
        null;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-criteria-footer/required.js